/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { alertMsg } from "../utilities/helper";
import { url } from "./api";
import { getAll, getOne } from "./helper";
import { jwt } from "./api";
import { preparePaginationData } from "../constant/common";
import { getAllClients } from "../services/clintServices";
import { getReq } from "../services/APIMethods";

export const getAllExpenses = createAsyncThunk(
  "expenses/getAllExpenses",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const getStatisticExpenses = createAsyncThunk(
  "expenses/getStatisticExpenses",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const postExpenses = createAsyncThunk(
  "airports/postExpenses",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    const urlAdd = `${url}/driversMonies`;
    try {
      const response = await axios({
        method: "post",
        url: urlAdd,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
        data: {
          driver_id: obj.driver_id,
          type: obj.type,
          amount: obj.amount,
          notes: obj.notes,
        },
      });
      alertMsg(" تمت العملية بنجاح", true);
      return response;
    } catch (err) {
      alertMsg("فشل اضافة البيانات حاول مرة اخري", false);
      return rejectWithValue(err);
    }
  }
);

export const ExpensesSlice = createSlice({
  name: "expenses",
  initialState: {
    render: false,
    id: null,
    edit: false,
    delete: false,
    loading: false,
    allExpenses: {},
    expensess: {},
    statistic:{},
    success: null,
    successData: null,
    allServiceInExpensess: [],
    error: "",
    errorMsg: null,
  },
  //handel reducers airports
  reducers: {
    //set Category ID
    setExpensetID(state, action) {
      state.id = action.payload.id;
    },
    // toggle Render airports
    renderAirports(state, action) {
      state.render = !state.render;
    },
    deleteAirportsRTK(state) {
      state.allCategory = state.allCategory.filter(
        (item) => item.id !== state.id
      );
    },
    //set Edit state
    setEdit(state, action) {
      state.edit = action.payload.edit;
    },
    //set Delete State
    setDelete(state, action) {
      state.delete = action.payload;
    },

    //set service by category
    setServicesAirports(state, action) {
      state.allServiceInAirports = action.payload.data;
    },
  },
  //get all airports apis
  extraReducers: {
    //get all airports data
    [getAllExpenses.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllExpenses.fulfilled]: (state, action) => {
      state.loading = false;
      state.allServiceInExpensess = action.payload?.data;
      state.success = action.payload.data.status;
    },
    [getAllExpenses.rejected]: (state, action) => {
      state.allExpenses = null;
      state.loading = false;
      // state.success = action.payload.response.data.success;
      // state.error = action.payload.response.data.error;
    },
    [getStatisticExpenses.pending]: (state, action) => {
      state.loading = true;
    },
    [getStatisticExpenses.fulfilled]: (state, action) => {
      state.loading = false;
      state.statistic = action.payload?.data;
    },
    [getStatisticExpenses.rejected]: (state, action) => {
      state.statistic = null;
      state.loading = false;

    },


    

    //get one airport
    [getOne.pending]: (state, action) => {
      state.loading = true;
    },
    [getOne.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = "";
      state.expensess = action.payload.data;
    },
    [getOne.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload.response.data.message;
    },

    //post airport
    [postExpenses.pending]: (state, action) => {
      state.loading = true;
      state.errorMsg = null;
    },
    [postExpenses.fulfilled]: (state, action) => {
      state.loading = false;
      state.successData = true;
      state.error = "";
    },
    [postExpenses.rejected]: (state, action) => {
      state.loading = false;
      state.successData = false;
      state.error = action.payload.response.data.message;
      state.errorMsg = action.payload.response.data.errors;
    },
  },
});
export default ExpensesSlice.reducer;
export const {
  setServicesAirports,
  setDelete,
  setEdit,
  deleteAirportsRTK,
  renderAirports,
  setExpensetID,
} = ExpensesSlice.actions;
